import { render, staticRenderFns } from "./EditAttrSpec.vue?vue&type=template&id=df0319e0&scoped=true"
import script from "./EditAttrSpec.vue?vue&type=script&lang=js"
export * from "./EditAttrSpec.vue?vue&type=script&lang=js"
import style0 from "./EditAttrSpec.vue?vue&type=style&index=0&id=df0319e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df0319e0",
  null
  
)

export default component.exports